import { getFeatureFlagValue } from '@citrite/feature-flags';
import {
	getResourceRID,
	ProjectsRoutePath,
	ResourceEntityType,
} from '@sharefiledev/projects-pilet-sdk';
import { RID } from '@sharefiledev/sfplugin-resource-id';
import { FeatureFlag } from '../featureFlags';

/**
 * Constructs navigation path based on feature flag
 * @param projectRID - The project RID string
 * @param options - Optional parameters for navigation
 * @returns Navigation path string
 */
export function constructProjectNavigationPath(
	requestedByResourceId: string,
	options: {
		targetExtensionSlotId?: string;
		projectNavigationPath?: string;
	} = {}
): string {
	const projectRID = getResourceRID(requestedByResourceId, ResourceEntityType.project);
	const enableProjectSolution = getFeatureFlagValue(FeatureFlag.EnableProjectAsSolution);

	// Parse project ID from RID
	const rid = RID.parse(projectRID);
	const projectEntity = rid.findEntityType('project');
	if (!projectEntity) {
		throw new Error(`No project resource found in RID: ${requestedByResourceId}`);
	}

	let webAppPath: string;
	if (enableProjectSolution) {
		// Expected Path:
		// /view/projects/details?projectRID={projectRID}
		// /view/projects/details?projectRID={projectRID}&activeTab={targetExtensionSlotId}&tab={targetExtensionSlotId} (if targetExtensionSlotId is provided)

		const queryParams = new URLSearchParams();
		queryParams.set('projectRID', projectRID);

		if (options.targetExtensionSlotId) {
			// To support legacy based project
			queryParams.set('tab', options.targetExtensionSlotId);
			queryParams.set('activeTab', options.targetExtensionSlotId);
		}

		webAppPath = `${
			ProjectsRoutePath.ProjectsAsSolution
		}/details?${queryParams.toString()}`;
	} else {
		// Expected Path:
		// /projects/{id}
		// /projects/{id}/{targetExtensionSlotId} (if targetExtensionSlotId is provided)

		const projectId = projectEntity.entityId;
		webAppPath = `/projects/${projectId}`;

		if (options.targetExtensionSlotId) {
			webAppPath = `${webAppPath}/${options.targetExtensionSlotId}`;
		}
	}

	if (options.projectNavigationPath) {
		// Expected Path:
		// projectNavigationPath = /view/tax/v1
		// /view/tax/v1?containerRID={projectRID}&projectRID={projectRID}
		// /view/tax/v1?containerRID={projectRID}&projectRID={projectRID}&activeTab={targetExtensionSlotId}  (if targetExtensionSlotId is provided)

		const url = new URL(window.location.origin + options.projectNavigationPath);
		const queryParams = new URLSearchParams(url.search);

		queryParams.set('projectRID', projectRID);
		queryParams.set('containerRID', projectRID);

		if (options.targetExtensionSlotId) {
			// To support legacy based project
			queryParams.set('tab', options.targetExtensionSlotId);
			queryParams.set('activeTab', options.targetExtensionSlotId);
		}

		return url.pathname + (queryParams.toString() ? `?${queryParams.toString()}` : '');
	}

	return webAppPath;
}
